"use strict";
export default function swapElements(obj1, obj2) {
  const temp = obj1.innerHTML;
  obj1.innerHTML = "";
  obj2.innerHTML = temp;
}
